
import CompetitionCreate from "../competition/CompetitionCreate";
import {  OffCanvas } from '../common';
import { Link } from "react-router-dom";

function toYMD(dateString) {
  const date = new Date(dateString);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function toESTTime(dateString) {
  const date = new Date(dateString);
  const estDate = new Date(date.toLocaleString("en-US", { timeZone: "America/New_York" }));
  const hours = estDate.getHours();
  const minutes = String(estDate.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const hr12 = hours % 12 || 12;
  return `${hr12}:${minutes} ${ampm}`;
}


export default function CompetitionTable({ show }) {


    return(
            <>

        <OffCanvas id='newCompetitionForm' title='Create a Class'>
            <CompetitionCreate show={show}></CompetitionCreate>
        </OffCanvas>

        <div className=' mb-2'>
                <button className='btn btn-azure' type='button' data-bs-toggle='offcanvas' data-bs-target='#newCompetitionForm'>
                    <i className='bi bi-plus-lg me-2'></i>
                   Add new Class
                </button>
            </div>
                <div className="table-responsive">
                    <table className="table table-striped table-bordered table-hover align-middle">
                    <thead >
                        <tr>
                        <th scope="col">Start Date</th>
                        <th scope="col">Start time(EST)</th>
                        <th scope="col">Order</th>
                        <th scope="col">Class Name</th>
                        <th scope="col">Class #</th>
                        <th>Disipline</th>
                        <th>Class Status</th>
                        <th>Class ID</th>
                        </tr>
                    </thead>
                    <tbody>

                        {
                            show.competitions && show.competitions.map((competition, index) => (
                                <tr key={index}>
                                    <td>{toYMD(competition.startDateTime)}</td>
                                    <td>{toESTTime(competition.startDateTime)}</td>
                                    <td>{competition.order === "" || competition.order === undefined ? "None" : competition.order }</td>
                                    <td>{
                                    <Link to={`/competition/${competition.id}`}>
                                    {competition.name}
                                    </Link>
                                    }</td>
                                    <td>{competition.classNumber}</td>
                                    <td>{competition.discipline.name}</td>
                                    <td>{competition.status}</td>
                                    <td>{competition.id}</td>
                                </tr>
                            ))

                        }

                    </tbody>
                    </table>
                </div>

            </>
    )
}